import React, { Component } from "react";
import Lottie from 'react-lottie';

import Animation from "./animation/Gif_007.json"
import "./style.scss";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: Animation,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

export class LoadGelBoxSolution extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  doneClicked =()=>{
    this.props.showModal({
      display: false
    })
    this.props.loadDNALadder(true)
  }

  render() {

    return (
      <div className="modal-section load-gelbox-solution" style={{ width: "calc(100% - 0px)", height: "650px", margin: "auto" }}>
        <div className="modal-header">
          <h2>Load Solution</h2>
        </div>

        <div className="modal-body">
          <div className="modal-inner">
            <Lottie
              options={defaultOptions}
              width={"auto"}
              height={"100%"}
              isStopped={this.state.isStopped}
              isPaused={this.state.isPaused} />
          </div>
        </div>

        <div className="modal-footer">

          <button
            aria-label="Done"
            tabIndex={this.props.tab}
            className="modal-btn-primary"
            onClick={this.doneClicked}>
              Done
          </button>

        </div>

      </div>

    );
  }
}
